import { useState, useEffect, useCallback, useMemo } from "react";
import { getPayoutRegisterWithPortfolioData } from "../../api/getPayoutRegisterWithPortfolioData";
import { HumanPayoutsWithPortfolioData } from "../../models/types/HumanPayoutsWithPortfolioData";
import { currencyFormatter } from "../../utils/currencyFormatter";
import Decimal from "decimal.js";
import { Assets } from "../../enums/assets";


// getPayoutRegisterWithPortfolioData -> HumanPayoutsWithPortfolioData[]

export default function HumanPayouts() {
  const [listElements, setListElements] = useState<HumanPayoutsWithPortfolioData[]>([]);
  const [spinner, setSpinner] = useState(false);

    useEffect(() => {

        const getList = async () => {
            const res = await getPayoutRegisterWithPortfolioData();
            setListElements(res);
        }

        getList();
    }, []);

    const getAssetPrice = useCallback((assetId: number, item: HumanPayoutsWithPortfolioData) => {
      return item?.portfolio?.summarization?.coinState.find(asset => asset.assetId === assetId)?.price.current ?? 0;
    }, []);
    

  return (
    <div className="m-5 p-5 bg-gray-100 rounded-lg shadow-lg">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">Tőke visszaadva:</h2>

      {spinner ? (
        <p className="text-center text-2xl animate-pulse">
          Kérlek várj még az adatok betöltődnek.
        </p>
      ) : (
        <div className="overflow-x-auto">
        <table className="min-w-full border-separate border-spacing-y-1">
          <thead className="bg-gray-100 sticky top-0">
            <tr>
              <th className="px-4 py-2 text-left text-sm font-medium text-gray-600">Azonosító</th>
              <th className="px-4 py-2 text-left text-sm font-medium text-gray-600">Dátum</th>
              <th className="px-4 py-2 text-left text-sm font-medium text-gray-600">Név</th>
              <th className="px-4 py-2 text-center text-sm font-medium text-gray-600">Csoport</th>
              <th className="px-4 py-2 text-right text-sm font-medium text-gray-600">Kifizetve (EUR)</th>
              <th className="px-4 py-2 text-right text-sm font-medium text-gray-600">Portfolio (USD)</th>
              <th className="px-4 py-2 text-right text-sm font-medium text-gray-600">BTC érték (USD)</th>
              <th className="px-4 py-2 text-right text-sm font-medium text-gray-600">ETH érték (USD)</th>
              <th className="px-4 py-2 text-right text-sm font-medium text-gray-600">Likviditás (USD)</th>
              <th className="px-4 py-2 text-center text-sm font-medium text-gray-600">Portfolio %</th>
            </tr>
          </thead>
          <tbody>
            {listElements.map((item, index) => (
              <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                <td className="px-4 py-2 text-sm font-semibold text-gray-500">{item.payoutRegister.depositRegister.id}</td>

                <td className="px-4 py-2 text-sm text-gray-800">{new Date(item.payoutRegister.date).toLocaleDateString()}</td>
                <td className="px-4 py-2 text-sm font-semibold text-gray-800">{item.payoutRegister.depositRegister.user.name}</td>
                <td className="px-4 py-2 text-sm text-center font-semibold text-gray-800">{item.payoutRegister.depositRegister.group.group_name}</td>

                <td className="px-4 py-2 text-sm text-right text-gray-800">
                  {currencyFormatter(item.payoutRegister.amount, "EUR")}
                </td>
                <td className="px-4 py-2 text-sm text-right text-gray-800">
                  {currencyFormatter(parseFloat(item.portfolio?.summarization?.totalValue.current.toString()), "USD")}
                </td>
                <td className="px-4 py-2 text-sm text-right text-gray-800">
                  {currencyFormatter(parseFloat(getAssetPrice(Assets.BTC, item).toString()), "USD")}
                </td>
                <td className="px-4 py-2 text-sm text-right text-gray-800">
                  {currencyFormatter(parseFloat(getAssetPrice(Assets.ETH, item).toString()), "USD")}
                </td>
                <td className="px-4 py-2 text-sm text-right text-gray-800">
                  {currencyFormatter(parseFloat(item.portfolio?.summarization?.totalLiquidity.current.toString()), "USD")}
                </td>
                <td className="px-4 py-2 text-sm text-center text-gray-800">
                  {item.portfolio?.summarization?.rate?.toString()}%
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      )}
    </div>
  );
}
